import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { toMonthDayYearFormat } from '@libs/utils';
import { TooltipModule } from '@libs/ui-lib';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { ReactiveFormsModule } from '@angular/forms';
import { SiteSetupComponentService } from '../site-setup/site-setup.component.service';
import { LicenseAgreementPracticeFormComponent, LicenseAgreementSignerFormComponent, LicenseAgreementSignBoxComponent } from './components';

@Component({
  selector: 'lib-license-agreement-form',
  imports: [
    CommonModule,
    LicenseAgreementPracticeFormComponent,
    LicenseAgreementSignerFormComponent,
    TranslateModule,
    LicenseAgreementSignBoxComponent,
    CdkAccordionModule,
    ReactiveFormsModule,
    TooltipModule,
  ],
  templateUrl: './license-agreement-form.component.html',
  styleUrl: './license-agreement-form.component.scss',
})
export class LicenseAgreementFormComponent {
  public today = toMonthDayYearFormat(new Date());
  public readonly service = inject(SiteSetupComponentService);

  private _showSignerEmail: boolean = false;
  private _showAuthorizedCheckbox: boolean = false;

  public get showSignerEmail(): boolean {
    return this._showSignerEmail;
  }

  @Input() public set showSignerEmail(value: boolean) {
    this._showSignerEmail = value;
    this.service.setShowSignerEmail(value);
  }

  public get showAuthorizedCheckbox(): boolean {
    return this._showAuthorizedCheckbox;
  }
  @Input() public set showAuthorizedCheckbox(value: boolean) {
    this._showAuthorizedCheckbox = value;
    this.service.showAuthorizedCheckbox(value);
  }
}
